import { FC, memo, useEffect } from 'react'
import { Modal, Flex } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import { ReactComponent as OfflineImg } from 'containers/authorised/setting/v2/payroll/PaymentProcess/components/icons/offline.svg'
import { useDispatch, useSelector } from 'utils/hooks'
import { offlinePaymentDetailsLoad } from 'redux/setting/payrollManagement/paymentMethods/actionCreators'
import { usePaymentMethod } from '../../components/usePaymentMethods'
import OfflineContent from './OfflineContent'

type propsType = { afterSubmit?: () => void }

const OfflinePaymentMethod: FC<propsType> = (props) => {
  const dispatch = useDispatch()
  const paymentCtx = usePaymentMethod()
  const { methodModalOpen, selectedPaymentMethod, setupModalOpen } = paymentCtx

  const paymentMethod = useSelector((s) => s.paymentMethods.current_payment_method)
  const offline = paymentMethod?.offline_payment_configuration

  const handleClose = (): void => {
    // ? @note incase the setup modal open we don't need to reset the current payment
    const data = setupModalOpen ? selectedPaymentMethod : null
    paymentCtx.handleMethodModalOpen(data, null)
  }

  useEffect(() => {
    if (selectedPaymentMethod && offline) {
      const data = {
        cr_id: selectedPaymentMethod.id,
        id: offline.bank_account.id,
      }
      dispatch(offlinePaymentDetailsLoad(data))
    }
  }, [methodModalOpen === 'offline'])

  return (
    <Modal
      isOpen={methodModalOpen === 'offline'}
      onClose={handleClose}
      variant="centerDialog"
      width={600}
      modalHeaderStyle={{ background: '#fff', padding: '24px 16px 16px', minHeight: 'auto' }}
      header={
        <Flex
          itemsCenter
          style={{ gap: 8 }}
        >
          <OfflineImg style={{ width: 32, height: 32 }} />
          <Typography
            variant="subtitle-1"
            style={{ lineHeight: '20px', color: 'var(--color-base-colors-grey-1000)' }}
            text={i18n.t('setup_offline')}
          />
        </Flex>
      }
    >
      <OfflineContent
        onClose={handleClose}
        afterSubmit={props.afterSubmit}
      />
    </Modal>
  )
}

export default memo(OfflinePaymentMethod)
